import { createListenerMiddleware } from '@reduxjs/toolkit'

import type { AppDispatch, RootState } from '@/store'

/**
 * Listener middleware (PX-W6.1) — the sanctioned home for CROSS-ACTION
 * effects (AC-11): cross-slice reactions that are not one reducer's business
 * live here, never inside a reducer.
 *
 * Registered listeners: the cache follow-ups (`store/cacheFollowUps.ts`,
 * TASK-3D6DB8B6). W6.1 registered none, deliberately: the session→realtime
 * propagation the spec describes is reactive (the realtime socket provider
 * re-arms from `selectActiveOrgId` + the token subscription on its own), and
 * the realtime fan-out is owned by the `EVENT_TYPE_MAP` rows, not by
 * listeners. The middleware is mounted NOW so later waves (session-expired
 * propagation, invalidation fan-out) add `startListening` rows here instead
 * of inventing side-effectful reducers. Keep this module free of I/O.
 *
 * Pre-typed over the store so `startListening` predicates and effects see
 * `RootState`/`AppDispatch` (the type-only import is erased at runtime — no
 * import cycle with `store/index.ts`).
 */
export const listenerMiddleware = createListenerMiddleware<RootState, AppDispatch>()

/** Pre-typed alias for later waves (`listenerMiddleware.startListening`). */
export const startAppListening = listenerMiddleware.startListening
